<template>
    <div class="modal-card container">
        <header class="modal-card-head">
            <p class="modal-card-title">Sign in</p>
        </header>
        <form class="modal-card-body" @submit.prevent="signIn">
            <fieldset :disabled="loading">
                <b-field label="Email">
                    <b-input type="email" v-model="login"/>
                </b-field>
                <b-field label="Password">
                    <b-input type="password" v-model="password" password-reveal/>
                </b-field>
                <div class="btn-holder">
                    <button class="button is-success" type="submit">Login</button>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'LoginForm',
    data() {
        return {
            login: '',
            password: '',
            loading: false
        }
    },

    methods: {
        auth (login, password) {
            const data = new URLSearchParams()
            data.append('login', login)
            data.append('password', password)

            return axios.post('https://auth.weproov.com/user/login', data, {
                params: {
                        response_type: 'id_token token',
                        scope: 'openid',
                        client_id: '0Vx3sm?uRJIOugPV'
                },
            })
        },

        async signIn() {
            this.loading = true;
            try {
                const res = await this.auth(this.login, this.password)
                this.$emit('connect', res.data.access_token)
                this.$emit('close')
            } catch (e) {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: `An error occured`,
                    type: 'is-danger'
                })
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.container {
  justify-content: space-between;
  flex-direction: column;
  display: flex;
}
.container .btn-holder {
  justify-content: flex-end;
  display: flex;
}
</style>
